module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1022.4ebd828a.png";